import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  controls: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'flex-end',
    color: theme.palette.textAlt,

    '& > :not(:last-child)': {
      marginRight: '0.5rem'
    }
  },

  info: {
    textAlign: 'center',
    marginBottom: '2rem',
    marginTop: '1.5rem'
  },

  listContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },

  option: {
    marginBottom: '1rem'
  },

  banner: {
    backgroundColor: theme.palette.banner.alert,
    borderRadius: '5px'
  },

  button: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  }
}))

export default useStyles
